import { Box } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import { Features } from 'generated/featureDefinitions'
import { ContributorsListPageDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import ContributorsDataCollection from 'modules/project_management/components/tables/ContributorsDataCollection'
import { MissingFeatureEmptyState } from 'modules/project_management/components/upsells/MissingFeatureEmptyState'
import { ProjectsUpsellRequestSources } from 'modules/project_management/components/upsells/constants'

const ContributorsListPageContent = ({ canManageRates }: { canManageRates: boolean }) => {
  return (
    <>
      {canManageRates && (
        <Box paddingBottom="s48">
          <SectionHeader
            title={i18n.t('project_management.people_and_rates.people_header.title')}
            description={i18n.t('project_management.people_and_rates.people_header.description')}
            link={{
              href: `https://help.factorialhr.com/${i18n.t(
                'project_management.projects.lower_case_title'
              )}`,
              label: i18n.t('project_management.people_and_rates.people_header.secondary_button'),
            }}
          />
        </Box>
      )}

      <ContributorsDataCollection canManageRates={canManageRates} />
    </>
  )
}

const ContributorsListPage = () => {
  useEffect(() => {
    track(trackingEvents.projectManagement.contributors.visitContributorsListSection)
  }, [])

  const { data: page, loading, error } = useQuery(ContributorsListPageDocument)

  const canManageRates = !!page?.projectManagement._policies.rateManage.can

  const canSeeContributors = !!page?.projectManagement._policies.pagesSeeContributorsList.can
  const canSeeContributorsUpsell =
    !!page?.projectManagement._policies.pagesSeeContributorsListUpsell.can
  const canSeePage = canSeeContributorsUpsell || canSeeContributors

  return (
    <ResponsivePage.Body variant="wide" loading={loading} error={error} authorized={canSeePage}>
      {canSeeContributorsUpsell ? (
        <Box alignItems="center" justifyContent="center" style={{ height: '50vh' }}>
          <MissingFeatureEmptyState
            featureRequested={Features.projects_contributors}
            requestSource={ProjectsUpsellRequestSources.contributors}
            description={i18n.t('project_management.upselling.people')}
          />
        </Box>
      ) : (
        <ContributorsListPageContent canManageRates={canManageRates} />
      )}
    </ResponsivePage.Body>
  )
}

export default ContributorsListPage
